import React from 'react';
import { useTranslation } from 'react-i18next';
import { Lock, Unlock } from 'lucide-react';

interface ProtectionToggleProps {
  isProtected: boolean;
  onToggle: () => void;
}

export default function ProtectionToggle({ isProtected, onToggle }: ProtectionToggleProps) {
  const { t } = useTranslation('createNote');

  return (
    <button
      type="button"
      onClick={onToggle}
      className={`
        flex items-center px-5 py-3 rounded-xl transition-all duration-200
        ${isProtected 
          ? 'bg-blue-500 text-white hover:bg-blue-600' 
          : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
        }
      `}
    >
      {isProtected ? (
        <>
          <Lock className="w-5 h-5 mr-2" />
          <span>{t('form.password.protected')}</span>
        </>
      ) : (
        <>
          <Unlock className="w-5 h-5 mr-2" />
          <span>{t('form.password.noPassword')}</span>
        </>
      )}
    </button>
  );
}